import pool from './db';
import { User, Kid, ScheduledMeal } from '../types';

export async function getUsers(): Promise<User[]> {
  const [users] = await pool.query<User[]>(`
    SELECT 
      u.id, u.first_name, u.last_name, u.email, u.phone_number,
      u.email_verified_at, u.phone_verified_at
    FROM users u
  `);

  // Fetch kids for each user
  for (const user of users) {
    const [kids] = await pool.query<Kid[]>(`
      SELECT 
        k.id, k.customer_id, k.school_id, k.name,
        k.birth_date, k.gender, k.card_token,
        c.uuid, c.id_vending_card
      FROM kids k
      LEFT JOIN codes c ON k.id = c.kid_id
      WHERE k.customer_id = ?
    `, [user.id]);

    user.kids = kids.map(kid => ({
      ...kid,
      code: kid.uuid ? {
        uuid: kid.uuid,
        id_vending_card: kid.id_vending_card
      } : undefined
    }));
  }

  return users;
}

export async function getScheduledMeals(date: string): Promise<ScheduledMeal[]> {
  const [meals] = await pool.query<ScheduledMeal[]>(`
    SELECT 
      m.id, m.order_id as orderId, k.id as kidId,
      k.name as kidName, k.birth_date as kidBirthDate,
      k.gender as kidGender, mi.id as mealId,
      mi.title as mealTitle, mi.type, mi.description,
      m.price, m.quantity as qty, m.for_date,
      m.shift, m.prepared, mi.image,
      n.nutritional_info->>'$.carbohydrates' as carbohydrates,
      n.nutritional_info->>'$.fat' as fat,
      n.nutritional_info->>'$.protein' as protein,
      n.nutritional_info->>'$.energy' as energy,
      n.nutritional_info->>'$.carbohydratesPercent' as carbohydratesPercent,
      n.nutritional_info->>'$.fatPercent' as fatPercent,
      n.nutritional_info->>'$.proteinPercent' as proteinPercent,
      n.nutritional_info->>'$.energyPercent' as energyPercent,
      m.note
    FROM meals m
    JOIN kids k ON m.kid_id = k.id
    JOIN meal_items mi ON m.meal_item_id = mi.id
    LEFT JOIN nutritional_info n ON mi.id = n.meal_item_id
    WHERE m.for_date = ?
  `, [date]);

  return meals;
}

export async function updateMealPrepared(mealId: number, prepared: boolean): Promise<void> {
  await pool.query(
    'UPDATE meals SET prepared = ? WHERE id = ?',
    [prepared, mealId]
  );
}